<template>
<el-dialog title="素材视频" :visible.sync="dialogVisible" width="770px" v-if="dialogVisible" >
    <div class="warp">
        <div class="video">
            <div class="left_menu_box">
                <!-- <div class="top_box" :class="leftMenuIsSelect == -1 ? 'is_select' : 'no_select'" @click="leftMenuClick(-1)">全部视频</div> -->
                <div class="video_list" v-for="(item,index) of videoCollection" :key="index" :class="leftMenuIsSelect == index ? 'is_select' : 'no_select'" @click="leftMenuClick(index, item.catalogid)">
                    <div>
                        <div>
                        <span class="el-dropdown-link">
                            {{item.catename}}
                        </span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right_main_box">
                <div class="video_content_list">
                    <div class="no_content" v-show="videoListData.length == 0">
                        <span>暂无内容</span>
                    </div>
                    <div class="video_content_box" v-show="videoListData.length !== 0">
                        <div class="video_box">
                            <div class="video_item" v-for="(item,index) of videoListData" :key="index">
                                <div>
                                    <div class="video_item_box">
                                        <img v-lazy="item.coveratturl" alt="">
                                        <span>{{playTime(item.videolength)}}</span>
                                        <p @click="selectImg(index)" :class="item.aboolean ? 'show' : 'normal'"></p>
                                    </div>
                                </div>
                                <div>
                                    <div>{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="page">
                            <el-pagination
                                background
                                @current-change="handleSizeChange"
                                :current-page.sync="pageParams.page"
                                :page-size="pageParams.pageSize"
                                :pager-count="11"
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </div>
                        <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                            <el-button @click="cancel">取 消</el-button>
                            <el-button type="primary" @click="sureAdd()">确 定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</el-dialog>
</template>

<script>
import {getColList, findAllVideo, findGroupVideo} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {log} from 'util';
export default {
    data() {
        return {
            dialogVisible: false,
            total: 0,
            pageParams: {
                page: 1,
                pageSize: 20
            },
            leftMenuIsSelect: 0, // 当前选中左侧菜单
            videoCollection: [], // 左侧视频合集菜单
            catalogInnerId: '', // 素材分类的innerid
            params: {
                name: '', // 视频合集名称
                type: 1
            },
            videoListData: [], // 右侧视频列表
            groupId: '', // 分类ID
            coverPicture: ''
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        sureAdd() {
            let list = []
            this.videoListData.forEach(obj => {
                if (obj.aboolean) {
                    list.push(obj)
                }
            })
            this.$emit('setVideo', list)
            this.cancel()
        },
        openDialog() {
            this.dialogVisible = true
            // this.getColListData()
            this.getAllVideo()
        },
        playTime(value) {
            var secondTime = value // 秒
            var minuteTime = 0 // 分
            var hourTime = 0 // 小时
            if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
                // 获取分钟，除以60取整数，得到整数分钟
                minuteTime = parseInt(secondTime / 60)
                // 获取秒数，秒数取佘，得到整数秒数
                secondTime = parseInt(secondTime % 60)
                // 如果分钟大于60，将分钟转换成小时
                if (minuteTime > 60) {
                    // 获取小时，获取分钟除以60，得到整数小时
                    hourTime = parseInt(minuteTime / 60)
                    // 获取小时后取佘的分，获取分钟除以60取佘的分
                    minuteTime = parseInt(minuteTime % 60)
                }
            }
            if (secondTime < 10) {
                secondTime = `0${secondTime}`
            }
            if (minuteTime < 10) {
                minuteTime = `0${minuteTime}`
            }
            if (hourTime < 10) {
                hourTime = `0${hourTime}`
            }
            var result = `${hourTime}:${minuteTime}:${secondTime}`
            return result
        },
        // 右侧图片列表单选
        selectImg(value) {
            this.videoListData[value].aboolean = !this.videoListData[value].aboolean
        },
        // 分页
        handleSizeChange(val) {
            // this.params.page = val
            console.log(this.params)
            this.pageParams.page = val
            var params = {
                catalogInnerId: this.groupId
            }
            this.setLoading(true)
            findAllVideo({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.videoListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 点击选中左侧菜单 添加背景色及相关操作
        leftMenuClick(value, id) {
            this.leftMenuIsSelect = value
            this.groupId = id
            this.pageParams.page = 1
            if (value === -1) {
                this.getAllVideo()
                this.groupId = ''
                return
            }
            this.getGroupVideo(this.groupId)
        },
        getGroupVideo(value) {
            this.setLoading(true)
            var params = {
                catalogInnerId: value
            }
            findGroupVideo({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.videoListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取合集列表data
        getColListData() {
            this.setLoading(true)
            var params = {
                materialtype: 1
            }
            getColList({
                data: Object.assign({}, params),
                success: data => {
                    this.videoCollection = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取所有的视频信息
        getAllVideo() {
            this.setLoading(true)
            findAllVideo({
                data: Object.assign({}, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    // console.log('所有的图片信息data:', data)
                    this.videoListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    if (this.pageParams.page === 1) {
                        this.videoCollection = data.data.cataloglist
                    }
                    this.leftMenuIsSelect = 0
                    this.videoListData.forEach(obj => {
                        this.$set(obj, 'aboolean', false)
                    })
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'permission'
        ])
    },
    components: {}
}
</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.video {
    display: flex;
    .left_menu_box{
        width: 150px;
        min-height: 500px;
        margin-right: 10px;
        border-right: 1px solid #DCDFE6;
        box-sizing: border-box;
        &>div{
            padding-right: 15px;
            border-right: 4px solid transparent;
            text-align: center;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 150px;
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(48,49,51,1);
            box-sizing: border-box;
        }
        &>div:hover{
            background:rgba(230,241,252,1);
        }
        .top_box{
            // background:rgba(230,241,252,1);
            border-right: 4px solid transparent;
            text-align: right;
            padding-right: 36px;
            cursor: pointer;
        }
        .img_list{
            border-right: 4px solid transparent;
            padding-right: 15px;
            .el-dropdown-link {
                cursor: pointer;
            }
            .el-icon--right {
                margin-left: 10px;
            }
            .el-dialog__header{
                display: flex;
                justify-content: space-between;
            }
            .el-dropdown {
                display: flex;
                line-height: 1;
                span{
                    display: inline-block;
                    width: 74px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .is_select{
            background:rgba(230,241,252,1);
            border-right: 4px solid #409EFF;
            color:rgba(64,158,255,1);
            .el-dropdown-link{
                color:rgba(64,158,255,1);
            }
        }
        .add_box{
            img{
                width: 12px;
                height: 12px;
                &:hover{
                    cursor: pointer;
                }
            }
            span{
                padding-left: 20px;
                &:hover{
                    cursor: pointer;
                }
            }
        }
    }
    .right_main_box{
        width: 100%;
        min-width: 500px;
        min-height: 500px;
        .top{
            height: 80px;
            border-bottom: 1px solid #DCDFE6;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 10px;
            .left_box{
                display: flex;
                .upload_box{
                    margin-right: 15px;
                }
                .tips_box{
                    width: 570px;
                    font-size:13px;
                    line-height:20px;
                    color:#909399;
                }
            }
            .right_box{
                display: flex;
                span{
                    margin-right: 15px;
                    margin-left: 20px;
                    // margin-top: 8px;
                    line-height:28px;
                    display: inline-block;
                    color:rgba(96,98,102,1);
                    white-space: nowrap;
                }
                button{
                    width:28px;
                    height:28px;
                    background:rgba(64,158,255,1);
                    color: #fff;
                    border: none;
                    border-radius: 100%;
                }
            }
        }
        .video_content_list{
            .no_content{
                background-image: url('../../../common/images/other/zwsj@2x.png');
                background-size:372px 269px !important;
                background-position:top center !important;
                background-repeat: no-repeat;
                height: 500px;
                // margin-top: 30px;
                color:rgba(144,147,153,1);
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .video_content_box{
                .video_box{
                    display: flex;
                    flex-wrap: wrap;
                    .video_item{
                        margin: 10px;
                        &>div:nth-of-type(1) {
                            width: 160px;
                            height: 90px;
                            position: relative;
                            cursor: pointer;
                            .video_item_box{
                                width: 160px;
                                height: 90px;
                                position: relative;
                                background-color: black;
                                img{
                                    width: 160px;
                                    height: 90px;
                                }
                                span {
                                    position: absolute;
                                    bottom: 2px;
                                    left: 6px;
                                    color: #fff;
                                }
                                p{
                                    width: 24px;
                                    height: 24px;
                                    position: absolute;
                                    top: 10px;
                                    left: 10px;
                                    display: none;
                                    cursor: pointer;
                                    background-image: url('../../../common/images/other/Shape@2x.png');
                                    background-size:24px 24px !important;
                                }
                                .show{
                                    display: block!important;
                                    background-image: url('../../../common/images/other/Shape2@2x.png');
                                }
                            }
                            .video_item_box:hover{
                                p{
                                    display: block;
                                }
                            }
                        }
                        &>div:nth-of-type(2){
                            margin-left: 10px;
                            padding: 5px 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            &>div:nth-of-type(1){
                                color: #303133;
                            }
                            &>div:nth-of-type(2){
                                label{
                                    color: #C0C4CC;
                                    margin-right: 10px;
                                }
                                &>span{
                                    color: #409EFF;
                                    margin-right: 10px;
                                }
                                &>span:hover{
                                    color: rgb(12, 130, 248);
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
                .page {
                    @include flexBox(center)
                }
            }
        }
    }
}
</style>
